const appConfig = {
  "name": "voip-v2",
  "version": "0.1.0",
  "stage": "prod",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6sh93rjqnQuszg697",
    "clientId": "4u3a5bj6ltjcdv4gi86heulgb",
    "redirectUris": [
      "https://voip-mr.atlas-apps.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://voip-mr.atlas-apps.mit.edu/logout"
    ],
    "scopes": [
      "digital-id/search",
      "digital-id/user",
      "openid",
      "profile",
      "voip/user"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_bCu6BU8d2",
    "userPoolWebClientId": "4u3a5bj6ltjcdv4gi86heulgb",
    "oauth": {
      "domain": "atlas-auth.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "openid",
        "profile",
        "voip/user"
      ],
      "redirectUris": [
        "https://voip-mr.atlas-apps.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://voip-mr.atlas-apps.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;